var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvocusNational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49512 21.1553H12.1025V25.4187H19.8177V21.1553H24.505L15.9977 12.6211L7.49512 21.1553Z",
    fill: "#0083C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3305 21.1237L15.9973 6.5813L10.3943 12.2683H6.07767V16.6486L1.66895 21.1237H5.05785L15.9973 10.3142L26.6315 21.1237H30.3305Z",
    fill: "#0083C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvocusNational);
export default __webpack_public_path__ + "static/media/advocus-national.522daa302f93c4b1501e44fd4303e21d.svg";
export { ForwardRef as ReactComponent };